import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';

export default class ChartWrapper extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    type: PropTypes.string,
  };

  static defaultProps = {
    type: 'bar',
  };

  constructor(props) {
    super(props);
    this.state = {
      type: props.type,
      isContextMenuOpen: false,
    };
  }

  renderChart = (type) => {
    const { data } = this.props;
    switch (type) {
      default:
      case 'bar': return (
        <Bar
          data={data}
          options={{scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                  suggestedMin: 0,
                  suggestedMax: 100
                }
              }],
              xAxes: [{
                  ticks: {
                      display: false,
                  }
              }]
            }}}
          onElementsClick={dataset => console.log(dataset)}
        />
      );
    }
  };

  render() {
    const { type } = this.state;
    const { headline } = this.props;
    return (
      <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 mb-4">
        {headline && <h1>{headline}</h1>}
        {this.renderChart(type)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/ChartWrapper.js